// +----------------------------------------------------------------------
// | Desc:提示层库
// +----------------------------------------------------------------------
import Vue from "vue";

// +----------------------------------------------------------------------
// | Desc:MSG提示信息封装，icon值见官网
// +----------------------------------------------------------------------
Vue.prototype.$msg = function (message, type, time = 1500, callback) {
  this.$Message.destroy();
  if (this.$isblank(type)) {
    type = "info";
  }
  this.$Message[type]({
    background: true,
    content: message,
    duration: time / 1000,
  });
  if (typeof callback == "function") {
    setTimeout(function () {
      callback();
    }, time);
  }
};

// +----------------------------------------------------------------------
// | Desc:alert提示信息封装，icon值见官网
// +----------------------------------------------------------------------
Vue.prototype.$alert = function (msg, type, title, callback) {
  this.$Message.destroy();
  if (!type) {
    type = "info";
  }
  var title = title || "提示信息";
  var content = "<p>" + msg + "</p>";
  switch (type) {
    case "info":
      this.$Modal.info({
        title: title,
        content: content,
      });
      callback && callback();
      break;
    case "success":
      this.$Modal.success({
        title: title,
        content: content,
      });
      callback && callback();
      break;
    case "warning":
      this.$Modal.warning({
        title: title,
        content: content,
      });
      callback && callback();
      break;
    case "error":
      this.$Modal.error({
        title: title,
        content: content,
      });
      callback && callback();
      break;
  }
};

// +----------------------------------------------------------------------
// | Desc:交互时候的提示信息
// +----------------------------------------------------------------------
// | Param:show{boolead} true显示加载层;false关闭加载层
// | Param:message 提示信息
// +----------------------------------------------------------------------
// | Reurn:void;
// +----------------------------------------------------------------------
Vue.prototype.$loading = function (show = true, message = "数据加载中...") {
  this.$Message.destroy();
  if (show) {
    this.$Message.loading({
      content: message,
      duration: 1000,
    });
  } else {
    this.$Message.destroy();
  }
};

// +----------------------------------------------------------------------
// | Desc: 二次确认框
// +----------------------------------------------------------------------
Vue.prototype.$confirm = function (confirm, callback) {
  this.$Modal.confirm({
    title: confirm["title"] || "操作提示",
    content: "<p>" + confirm["msg"] || "您确认要执行该操作吗？" + "</p>",
    onOk: () => {
      callback && callback();
    },
  });
};

// +----------------------------------------------------------------------
// | Desc:表格选择改变事件处理
// +----------------------------------------------------------------------
Vue.prototype.$tableSeletChange = function (e, that,msg) {
  that.selectedRows = that.$arrTocomma(e);
  if (that.selectedRows.length > 0) {
    // that.$msg("您选中的数据：" + that.selectedRows);
  } else {
    // that.$msg("您取消了选择");
  }
};

// +----------------------------------------------------------------------
// | Desc:打开图片
// +----------------------------------------------------------------------
Vue.prototype.$openImg = function (url, name) {
  var url = this.$httpImg(url);
  var name = name || "图片预览";
  this.$QHImgopen.url(url, name);
};

// +----------------------------------------------------------------------
// | Desc:复制文本(可空格可换行)
// +----------------------------------------------------------------------
Vue.prototype.$copyText = function (text, callback) {
  var _this = this;
  return new Promise((resolve, reject) => {
    // 创建隐形防护容器（彻底隔离DOM影响）
    const safeContainer = document.createElement("div");
    Object.assign(safeContainer.style, {
      position: "fixed",
      left: "-99999px", // 移出可视区域
      opacity: "0", // 完全透明
      pointerEvents: "none", // 禁止任何交互
      userSelect: "none", // 防止意外选择
    });

    // 创建高兼容性文本域
    const textarea = document.createElement("textarea");
    Object.assign(textarea.style, {
      width: "1px", // 最小化尺寸
      height: "1px",
      margin: "0",
      padding: "0",
      border: "0",
      outline: "0",
      overflow: "hidden", // 隐藏滚动条
      whiteSpace: "pre", // 关键设置：保留所有空格和换行
    });
    textarea.setAttribute("readonly", ""); // 防止移动端键盘弹出
    textarea.value = text; // 自动保留原始空格/换行格式

    // 组装隔离环境
    safeContainer.appendChild(textarea);
    document.body.appendChild(safeContainer);

    // 现代浏览器优先方案
    const modernCopy = () => {
      navigator.clipboard
        .writeText(text)
        .then(() => success())
        .catch((err) => {
          legacyCopy(); // 降级到传统方案
        });
    };

    // 传统浏览器兼容方案
    const legacyCopy = () => {
      try {
        textarea.select();
        textarea.setSelectionRange(0, 99999); // 兼容移动端
        document.execCommand("copy") ? success() : fail();
      } catch (err) {
        fail(err);
      }
    };

    // 成功处理
    const success = () => {
      cleanup();
      _this.$msg("复制成功", "success"); // 第一个参数改文字，第二个保持类型标识
      callback&&callback();
    };

    // 失败处理
    const fail = (err) => {
      cleanup();
      _this.$msg("复制失败,浏览器不兼容", "error"); // 第一个参数改文字，第二个保持类型标识
    };

    // 安全清理
    const cleanup = () => {
      if (safeContainer.parentNode) {
        safeContainer.parentNode.removeChild(safeContainer);
      }
    };

    // 执行主逻辑
    if (navigator.clipboard) {
      modernCopy();
    } else {
      legacyCopy();
    }
  });
};


// +----------------------------------------------------------------------
// | Desc: 二次确认框(同步)
// +----------------------------------------------------------------------
Vue.prototype.$confirmSys = function (confirm) {
  return new Promise((resolve) => {
    this.$Modal.confirm({
      title: confirm.title || "操作提示",
      content: "<p>" + (confirm.msg || "您确认要执行该操作吗？") + "</p>",
      onOk: () => resolve(true), // 用户点击确认时 resolve(true)
      onCancel: () => resolve(false), // 用户点击取消时 resolve(false)
    });
  });
};